"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Value_1 = require("./Value");
class TimeSignature {
    constructor(beatsPerMeasure, parameter) {
        this.beatsPerMeasure = beatsPerMeasure;
        if (typeof parameter === "number") {
            this.oneBeat = new Value_1.default(Value_1.default.Type.fromBaseDuration(1.0 / parameter));
        }
        else {
            this.oneBeat = parameter;
        }
    }
    getDurationOfMeasure() {
        return this.beatsPerMeasure * this.oneBeat.getDuration();
    }
    getBeatsPerMeasure() {
        return this.beatsPerMeasure;
    }
    getOneBeat() {
        return this.oneBeat;
    }
}
TimeSignature.COMMON_TIME = new TimeSignature(4, Value_1.default.QUARTER);
exports.default = TimeSignature;
